// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"27":"59a11f95","138":"3d58740b","195":"54aef127","212":"ddebbf5e","220":"148704fa","456":"7097604b","481":"b4683e12","662":"85419d70","757":"6923c507","808":"f27472b2","829":"5af5b23b","848":"9f2567e1","871":"3e5c5f3e"}[chunkId] + ".js";
};